import React from "react";
import { Route, Switch } from "react-router-dom";
import FieldAppHome from "./FieldAppHome";

function FieldAppRoutes() {
  return (
    <Switch>
      <Route path="/:farm_id/field-app/" component={FieldAppHome} />
    </Switch>
  );
}

export default FieldAppRoutes;
